import { useCallback, useContext } from 'react'
import { useContentStack as useContentStackLib } from '@jarvis/olex-content-management'
import { USE_CONTENTSTACK_QUERY_TYPES } from '../store/Constants'
import { ConfigContext } from '../store/ConfigContext'

const useContentStack = (
  content_type,
  parsing_function = (data) => data,
  query_type = null,
  additional_params = {}
) => {
  const { printerFamily } = useContext(ConfigContext)
  const buildQuery = useCallback(
    ({ query, additional_params, newQuery }) => {
      const { instruction, tenant_type, type, operatingSystem } =
        additional_params

      const taxQuery = newQuery().or(
        newQuery().notExists(`taxonomies.printer_family`),
        newQuery().where(`taxonomies.printer_family`, printerFamily)
      )

      let finalQuery = query.and(taxQuery)

      if (instruction) {
        finalQuery = finalQuery.and(newQuery().where('type', instruction))
      }
      if (operatingSystem) {
        finalQuery = finalQuery.and(
          newQuery().or(
            newQuery().notExists('operating_system.operating_system'),
            newQuery().where('operating_system.operating_system', {
              $in: [operatingSystem.toUpperCase()]
            })
          )
        )
      }
      if (tenant_type) {
        finalQuery = finalQuery.and(
          newQuery().where('tenant_type.tenant', tenant_type)
        )
      }
      if (query_type === USE_CONTENTSTACK_QUERY_TYPES.SIDEBAR_TYPE && type) {
        finalQuery = finalQuery.and(newQuery().where('type', type))
      }
      return finalQuery
    },
    [additional_params, parsing_function, query_type]
  )

  const query_modifier = useCallback(
    (query, newQuery) => {
      if (query_type) {
        return buildQuery({
          query,
          content_type,
          additional_params,
          newQuery
        })
      }
      return query
    },
    [buildQuery, query_type, content_type, additional_params]
  )

  const { pageData } = useContentStackLib({
    content_type,
    parsing_function,
    query_modifier
  })

  return {
    pageData: pageData?.data,
    pageError: pageData?.error,
    status: pageData.status
  }
}

export default useContentStack
